import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
// used to create fake backend
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './Modulos/shared/shared.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeEs from '@progress/kendo-angular-intl/locales/es/all';
// Interfaces
import { Config } from '@/Interfaces/general/config';
import Package from '../../package.json';
import { ErrorInterceptor } from './Servicios/Autenticacion/error.interceptor';
import { CaptchaModule } from 'ng-captcha';
import { registerLocaleData, DatePipe } from '@angular/common';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { GlobalService } from './Servicios/global.service';
import { HomeModule } from './Modulos/home/home.module';;


registerLocaleData(localeEs, 'es-ES');

export function iniciar(http: HttpClient, globalService: GlobalService): (() => Promise<boolean>) {
  return (): Promise<boolean> => {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      let config: Config = {};
      const jsonFile = 'assets/config/config.json';
      http.get(jsonFile).toPromise().then((ConfigJson: Config) => {
        //config.urlAPISeguridad = ConfigJson.urlAPISeguridad;

        config.defaultImage = ConfigJson.defaultImage;
        //config.directorioNAP = ConfigJson.directorioNAP;

        config.urlApiSoat = ConfigJson.urlApiSoat;
        config.urlApiOfv = ConfigJson.urlApiOfv;
        config.urlTrtamientoDatos = ConfigJson.urlTrtamientoDatos;
        config.rutaRegreso = ConfigJson.rutaRegreso;        
        
        config.pIdGrupoCausa = ConfigJson.pIdGrupoCausa;
        config.pRadicadorIPSSede = ConfigJson.pRadicadorIPSSede;
        config.pMedioRecepcion = ConfigJson.pMedioRecepcion;
        config.pIdSitioRecepcion = ConfigJson.pIdSitioRecepcion;
        config.pTipoContacto = ConfigJson.pTipoContacto;
        config.pIdTipoContacto = ConfigJson.pIdTipoContacto;
        config.pComentariosRadicador = ConfigJson.pComentariosRadicador;
        config.pProductoTipoContacto = ConfigJson.pProductoTipoContacto;
        config.pEsIndividual = ConfigJson.pEsIndividual;
        config.pReceptor = ConfigJson.pReceptor;
        config.pPrioridad = ConfigJson.pPrioridad;
        config.pAsignadoA = ConfigJson.pAsignadoA;

        /*         if(config.EjecutarLocal){
                  config.IdUsuario = ConfigJson.IdUsuario; 
                  config.Token = ConfigJson.Token; 
                  config.IdPadre = ConfigJson.IdPadre; 
                } */

        config.tipoUsuario = ConfigJson.tipoUsuario;
        config.tipoIdEmpleador = ConfigJson.tipoIdEmpleador;
        config.IdEmpleador = ConfigJson.IdEmpleador;
        config.TipoIdUsuario = ConfigJson.TipoIdUsuario;
        config.IdUsuario = ConfigJson.IdUsuario;
        config.CodigoAsesor = ConfigJson.CodigoAsesor;
        config.Clave = ConfigJson.Clave;

        sessionStorage.setItem('configOficina', JSON.stringify(config));
        if (globalService != undefined) {
          globalService.config = config;
        }

        let campollave = btoa("campoLlavePublicaOficinaVirtual");
        let llave = ConfigJson[campollave];
        sessionStorage.setItem(campollave, llave);


        let dicDatosSesion: any[] = [];
        let objSesionUsuario: any = {};
        objSesionUsuario.maquina = '';
        objSesionUsuario.fecha = new Date();
        objSesionUsuario.version = Package.version;
        dicDatosSesion.push({ key: 'Version', data: objSesionUsuario.version });

        sessionStorage.setItem('datosSesion', JSON.stringify(dicDatosSesion));

        resolve(true);
      });
    });
  };
}

@NgModule({
  declarations: [
    AppComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    LayoutModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxSpinnerModule,
    CaptchaModule,
    ScrollViewModule,
    HomeModule

  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: iniciar,
      deps: [
        HttpClient,
        GlobalService
      ],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: ErrorInterceptor },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }